"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var authentication_1 = require("@dynamynd/authentication");

var components_lib_1 = require("@dynamynd/components-lib");

var content_1 = require("@dynamynd/content");

var core_1 = require("@dynamynd/core");

var routes_1 = require("@dynamynd/routes");

var user_1 = require("@dynamynd/user");

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var store_1 = require("../../store");

var BootstrapWebScreen =
/** @class */
function (_super) {
  __extends(BootstrapWebScreen, _super);

  function BootstrapWebScreen(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      route: routes_1.RoutesKeysEnum.login
    };

    _this.props.bootstrapApplication();

    _this.props.getContentForSharing();

    return _this;
  }

  BootstrapWebScreen.prototype.componentDidMount = function () {
    this.validateAuth();
  };

  BootstrapWebScreen.prototype.componentDidUpdate = function () {
    var activePathName = core_1.locationWebService.getActivePathName();
    var navigation = this.props.navigation; // pass the query params to the child routes

    var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search); // there's no other way to refresh the current screen if you're on the same URL -> e.g. refresh on /home would not do anything without passing a new object

    if (this.state.route === activePathName) {
      navigation.navigate(this.state.route, params);
      return;
    }

    navigation.navigate(this.state.route, params);
  };

  BootstrapWebScreen.prototype.validateAuth = function () {
    var isAuthenticated = authentication_1.authService.isAuthenticated();
    var activePathName = core_1.locationWebService.getActivePathName();

    if (isAuthenticated) {
      this.props.getUserProfile({
        activeRoute: activePathName,
        withRedirect: true
      });
      return;
    } // if the current route is one of anonymousRoutesWithoutRedirect


    if (!this.shouldRedirectHome(activePathName)) {
      this.setState({
        route: activePathName
      });
      return;
    }

    this.setState({
      route: routes_1.RoutesKeysEnum.home
    });
  };

  BootstrapWebScreen.prototype.shouldRedirectHome = function (activePathName) {
    return core_1.locationWebService.anonymousRoutesWithoutRedirect.indexOf(activePathName) < 0;
  };

  BootstrapWebScreen.prototype.render = function () {
    return react_1.default.createElement(components_lib_1.LoadingIndicator, {
      size: "large",
      fullScreen: true
    });
  };

  return BootstrapWebScreen;
}(react_1.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserProfile: redux_1.bindActionCreators(user_1.getUserProfileActionCreator, dispatch),
    bootstrapApplication: redux_1.bindActionCreators(store_1.bootstrapApplicationActionCreator, dispatch),
    getContentForSharing: redux_1.bindActionCreators(content_1.getContentForSharingActionCreator, dispatch)
  };
};

var hoc = react_redux_1.connect(null, mapDispatchToProps);
exports.default = hoc(BootstrapWebScreen);